<p-dialog [(visible)]="visible" [modal]="true" [style]="{ width: '60vw' }" [closable]="true" (onHide)="onClose()">
  <ng-template pTemplate="header">
    <h3 class="titulo-explicacion border-b-2 w-full">{{ title }}</h3>
  </ng-template>

  <ng-template pTemplate="content">
    <div class="contenido-explicacion" [innerHTML]="contenido"></div>
  </ng-template>
</p-dialog>
